import { withNavigationWatcher } from "./contexts/navigation";
import {
  CategoryPage,
  DangKySizeComboPage,
  DonGiaPage,
  DonHangPage, DonHangSalePage,
  DonHangSummaryPage, DonViTinhPage,
  KhoPage, NhapKhoPage,
  SanPhamChiTietPage,
  SanPhamPage, SetTieuChuanHocSinhPage,
  SetTieuChuanPage,
  TrangThaiKhoPage
} from "./pages";

const routes = [
  {
    path: "/home",
    component: DonHangPage,
  },
  {
    path: "/uf_kho",
    component: KhoPage,
  },
  {
    path: "/uf_sanpham",
    component: SanPhamPage,
  },
  {
    path: "/uf_dongia",
    component: DonGiaPage,
  },
  {
    path: "/uf_donhang_summary",
    component: DonHangSummaryPage,
  },
  {
    path: "/uf_register_size_combo",
    component: DangKySizeComboPage,
  },
  {
    path: "/uf_donhang_sales",
    component: DonHangSalePage,
  },
  {
    path: "/uf_donhang",
    component: DonHangPage,
  },
  {
    path: "/uf_nhapkho",
    component: NhapKhoPage,
  },
  {
    path: "/uf_category",
    component: CategoryPage,
  },
  {
    path: "/uf_donvitinh",
    component: DonViTinhPage,
  },
  {
    path: "/uf_settieuchuan",
    component: SetTieuChuanPage
  },
  {
    path: "/uf_settieuchuan_hocsinh",
    component: SetTieuChuanHocSinhPage
  },
  {
    path: "/uf_sanphamchitiet",
    component: SanPhamChiTietPage,
  },
  {
    path: "/uf_trangthaikho",
    component: TrangThaiKhoPage,
  }
];

export default routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});
